@if (popoverData()) {
  <div>
    @for (entry of (subjectData | async | keyvalue); track entry) {
      <div class="popover-body">
        @for (item of entry.value; track item) {
          <div class="popover-row" [class.title]="item.isTitle">
            @if (item.link) {
              <a class="external-link" [href]="item.displayValue" target="_blank"> {{ item.displayText }}</a>
            } @else {
              @if (item.displayText) {
                <span>{{ item.displayText }}
                  @if (item.infoText) {
                    <mat-icon inline [matTooltip]="item.infoText">info_outlined</mat-icon>
                  }
                </span>
              }
              <span>{{ item.displayValue }}</span>
            }
          </div>
        }
      </div>
      <div class="popover-footer">
        <span>{{ entry.key }} layer </span>
      </div>
    }
  </div>
} @else {
  There is no data
}
